import React, { Component }from 'react';
import { connect } from 'react-redux';
import dataModel from '../../../models/DataModel';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import './MobileBadConnectionAlert.scss';

export class MobileBadConnectionAlert extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bannerText: 'You have connection problems. Active offline mode',
      retrying: false,
      shown: false,
    };
    this.closeBanner = this.closeBanner.bind(this);
    this.handleClick = this.handleClick.bind(this);
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
   
    // this.history = new OurHistory(createBrowserHistory(), props.mobileBridge);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 10);
  }

  shouldComponentUpdate(nextProps){
    if(nextProps.badConnection == true){
      this.closeBanner();
    }
    return true;
  }

  closeBanner() {
    return new Promise((resolve) => {
      // wait for animation to actually close banner
      setTimeout(() => {
        this.setState({ shown: false });
        resolve();
        // hide the component
        this.props.dataModel.hideGlobalBanner(this.props.bannerType);
        // window.location.reload()
      }, 150);
    });
  }

  handleClick(e){
    e.stopPropagation();
    this.props.mobileBridge.router.push('/mobile/settings');
    
  }
  
  render() {

    return (
      <div className={'offline-banner ' + (this.state.shown ? '' : 'offline-banner--closing')}>
        <div className='offline-banner__text'>{this.state.bannerText}</div>
        { !this.state.retrying && 
          <div className='offline-banner__retry' onClick={this.handleClick}>
               Go settings.       
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    dataModel: dataModel,
    badConnection: state.main.badConnection,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps)(MobileBadConnectionAlert);



// WEBPACK FOOTER //
// ./src/components/banners/MobileBadConnectionAlert/index.js